import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import './SharePoll.scss';
import {API_URL} from '../../utils/axios'
import axios from 'axios'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Link} from 'react-router-dom'


const SharePoll = ({match}) => {
    const [loading, setLoading] = useState(true);
    const [pollPin, setPollPin] = useState({});
    const[copied, setCopied] = useState(false);
    useEffect(() => {
        axios.defaults.headers['foodrtoken'] = localStorage.getItem("token")
        
        axios.get(API_URL + '/poll/get/' + match.params.id).then(response => {
            setPollPin(response.data)
            setLoading(false)
        }).catch(error => console.log(error))
     
    }, [match])

    
        
    return (
            <div className="share">
                <div className="share__header-container">
                    <p className="share__header">You're Almost There!</p>
                </div>
                <div className="share__text-container">
                    <p className="share__text-message">Simply copy the pin below and share to provide other's with access to your poll!</p>
                </div>
                {/* <p className="share__instructions">Simply copy the pin below to give others access to your poll!</p> */}
               {!loading &&  <div className="share__pin-container">
                    <div type="text" className="share__pin">{pollPin.pin}</div>
                    
                    <CopyToClipboard 
                        text={pollPin.pin}
                        onCopy={() => setCopied(true)}>
                        <div className="share__button-container">
                            <button className="share__button">Copy Pin</button>
                            {copied ? <span className="share__copied-message"style={{color: 'red'}}>Copied.</span> : null}
                        </div>    
                    </CopyToClipboard>
                    
                </div>}
                <div className="share__dashboard-container">
                    <Link to="/dashboard" className="share__dashboard">Return to Dashboard</Link>
                </div>
            </div>
    );
};

export default withRouter (SharePoll);